/**
 * Route for `advertiser-commission`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserCommissionPage } from "../features/advertiser-commission/AdvertiserCommissionPage";

export const advertiserCommissionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-commission",
	component: AdvertiserCommissionPage,
});

export default advertiserCommissionRoute;
